import React, { useState, useEffect } from "react";
import "./Login.css";
import { Input, Password } from "../usefulcomps/HexInput/InputBox";
import Button from "../usefulcomps/HexButton/button";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { IoKey } from "react-icons/io5";
import imgLogo from "../Images/nahatalogo.jpeg";

export default function Login() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userlabelcolor, setuserlabelcolor] = useState("black");
  const [passlabelcolor, setpasslabelcolor] = useState("black");
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const navigate = useNavigate();
  const setSessions = (str) => {
    console.log(str);
    while (str.toLowerCase().includes("localstorage.setitem")) {
      console.log(str);
      let key = str.substring(str.indexOf('("') + 2, str.indexOf('",'));
      let value = str.substring(str.indexOf(",") + 2, str.indexOf('")'));
      localStorage.setItem(key, value);
      str = str.replace(`localStorage.setItem("${key}","${value}");`, "");
    }
  };
  const generateSessionId = (length = 32) => {
    const array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
      "",
    );
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(username);
    console.log(password);
    if (!username.trim() || !password.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Username and Password are required.",
        confirmButtonColor: "#000",
      });
      return;
    }
    const sessionID = await generateSessionId();
    let obj = {
      query: `[dbo].[CRM_Proc_Login_Validation] @SessionID='{0}',@Username='{1}',@Password='{2}'`,
      queryArr: [`${sessionID}`, `${username}`, `${password}`],
    };
    Hexapi(obj).then((resp) => {
      console.log(resp);
      if (resp[""][0]["command"] == 0) {
        Swal.fire({
          html: `${resp[""][0]["msg"]}`,
          confirmButtonColor: "#000",
        });
      } else {
        localStorage.setItem("SessionID", sessionID);
        navigate("/dg");
      }
    });
  };

  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <Input
            labelStyle={{ fontWeight: "600", color: `${userlabelcolor}` }}
            label={
              <span style={{ fontWeight: 600, color: userlabelcolor }}>
                <FaUser
                  size={18}
                  style={{ marginRight: "6px", marginBottom: "3px" }}
                />
                Username
              </span>
            }
            type="text"
            className="form-control"
            name="username"
            value={username}
            inline={false}
            onChange={(event) => setusername(event.target.value)}
            required
          />
        </div>
        <div className="input-container">
          <Input
            labelStyle={{ fontWeight: "600", color: `${passlabelcolor}` }}
            label={
              <span style={{ fontWeight: 600, color: userlabelcolor }}>
                <IoKey size={20} style={{ marginRight: "6px" }} />
                Password
              </span>
            }
            type="password"
            className="form-control"
            name="password"
            value={password}
            onChange={(event) => setpassword(event.target.value)}
            inline={false}
            required
          />
        </div>

        <div className="button-container">
          <Button buttonTitle="Login" />
          {/* <span onClick={handleforget} style={{ cursor: "pointer", width: "150px", margin: "15px", borderRadius: "10px", fontSize: "15px", fontWeight: "semi-bold", fontfamily: "system-ui" }}>Forget Password!!</span> */}
        </div>
      </form>
    </div>
  );

  return (
    <>
      <div className="app">
        <div className="appflex">
          <div className="login-form">
            <img
              src={imgLogo}
              alt="Logo"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            {/* <div className="title">LOGIN</div> */}
            {isSubmitted ? <div>You can achive your goal</div> : renderForm}
          </div>

          {/* <div style={{ display: "flex", flexDirection: "column", margin: "30px" }}>
            <span style={{ fontWeight: "100" }}>Designed and Powered by</span>
            <img style={{ width: "150px", margin: "0px 0px 0px 20px" }} src={process.env.PUBLIC_URL + "HEX Logo.png"} />

          </div> */}

          {/* {
              isOpenSupport &&
              <Support
                openModal={isOpenSupport}
                closeModal={() => setisOpenSupport(false)}
                user={username}
              />
            } */}
        </div>
      </div>
    </>
  );
}
